import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className, y = 24 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <p className="flex items-center gap-2.5 text-[11px] uppercase tracking-[0.3em] font-semibold text-mute">
        <span className="inline-block h-1.5 w-1.5 bg-ochre" aria-hidden="true" />
        {children}
    </p>
);
